import { Component, OnInit } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';

@Component({
  selector: 'multi-select-accessibility',
  templateUrl: './multi-select-accessibility.component.html',
  styleUrls: ['./multi-select-accessibility.component.sass']
})
export class MultiSelectAccessibilityComponent implements OnInit {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;

  constructor(private templateService: TemplateUpdateService) { }

  ngOnInit(): void {
  }

}
